export default __webpack_public_path__ + "static/media/money_charge.e7d37b50.png";